export class BaseDto {
  public id?: number;
}
